export const Modal = `

	import { Button, Modal, ModalVariant } from 'base-ui'
	const [isModalOpen, setIsModalOpen] = React.useState(false)

	const handleClose = () => {
		setIsModalOpen(false)
	}

	<div>
		<Button
			color='primary'
			label='Open Modal'
			onClick={() => setIsModalOpen(true)}
		/>
		<Modal
			label="Modal Title" //String
			variant={ModalVariant.passive} // Enum: passive, acknowledgement, transactional
			color="primary" // String: primary, warning, danger, success, info
			open={isModalOpen} // Bolean
			onClose={handleClose} // Function
			icon="danger" // String: warning, danger, success
			iconCustom={<IconCog />} // ReactNode: BaseIcons
			size="md" // String: sm, md, lg
		>
			Text in a modal
		</Modal>
	</div>
`
